import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swiper from "swiper/bundle";

gsap.registerPlugin(ScrollTrigger);

function scrollContent() {
    //console.log('scrollContent');
    
    // Clean up previous Swiper and ScrollTrigger instances if they exist
    // Kill all Swiper instances in .scroll-content-slider
    const prevSlider = document.querySelector('.scroll-content-slider');
    if (prevSlider && prevSlider.swiper) {
        prevSlider.swiper.destroy(true, true);
    }
    // Kill all ScrollTrigger instances for .scroll-content-pinup and .scroll-content-trigger
    if (typeof ScrollTrigger !== 'undefined') {
        ScrollTrigger.getAll().forEach(trigger => {
            if (
                (trigger.trigger && (trigger.trigger.classList.contains('scroll-content-pinup') || trigger.trigger.classList.contains('scroll-content-trigger') || trigger.trigger.classList.contains('slidertrigger')))
            ) {
                trigger.kill();
            }
        });
        ScrollTrigger.refresh();
    }

    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var pipupEle = document.querySelector('.scroll-content-pinup');
    var sliderWrapEle = document.querySelector('.scroll-content-trigger');
    const slider = document.querySelector('.scroll-content-slider');    
    var swiperOp;

    if (!pipupEle) return;
    if (!sliderWrapEle) return;
    if (!slider) return;

    if(w < 767) {
        var swiperOp = new Swiper(slider, {
            init: false,
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            autoplay: false, 
            breakpoints: {            
                760: {
                    spaceBetween: 30,
                }
            } ,              
        });
        swiperOp.on('slideChange', function (i) {
            //console.log('slideChange');  
        });
        swiperOp.on('afterInit', function (i) {
            //console.log('afterInit');            
        });
        swiperOp.init();
        return;
    } else {
        // change swiper slider with scroll element ".slidertrigger"
        var swiperOp = new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 30,
            speed: 1000,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
              },
            autoplay: false,             
        });

        swiperOp.on('slideChange', function (i) {
            //Stop all video inside this slider
            slider.querySelectorAll("video").forEach((video) => {
                if (!video.paused) video.pause();
            });
            document
                .querySelectorAll(".js-playvideo.hide")
                .forEach((btn) => btn.classList.remove("hide"));
            document
                .querySelectorAll(".header-content-box.hide")
                .forEach((box) => box.classList.remove("hide"));
            document
                .querySelectorAll(".js-pause-button")
                .forEach((btn) => btn.classList.add("hide"));

            //play video here if found in new slide  
            const activeSlide = swiperOp.slides[swiperOp.activeIndex];
            const activeWrap = activeSlide.querySelector('.videowrap');
            if (activeWrap) {
                const playBtn = activeWrap.querySelector('.js-playvideo');
                const pauseBtn = activeWrap.querySelector('.js-pause-button');
                if (playBtn) playBtn.classList.add('hide');
                if (pauseBtn) pauseBtn.classList.remove('hide');

                const activeVideo = activeWrap.querySelector('video');
                if (activeVideo) {
                    activeVideo.play().catch(err => {
                        if (playBtn) playBtn.classList.remove('hide');
                        if (pauseBtn) pauseBtn.classList.add('hide');
                        console.log('Autoplay blocked, user interaction needed.');
                    });
                }
            }
        });
        
        

        var tl = gsap.timeline({
            scrollTrigger: {
                //markers: true,
                trigger: pipupEle,
                pin: true,
                //pinSpacing: false,
                start: 'top 10%',
                endTrigger: sliderWrapEle,
                end: 'bottom 60%',
            }
        });    
        
        var tl2 ='';
        var sliderTiggers = document.querySelectorAll('.slidertrigger');
        if (sliderTiggers.length === 0) return;
        sliderTiggers.forEach(function (trigger, index) {
            tl2 = gsap.timeline({
                scrollTrigger: {
                    //markers: true,
                    trigger: trigger,
                    start: 'top 45%',
                    end: 'bottom 55%',
                    scrub: 1,
                    onEnter: function () {
                        swiperOp.slideTo(index);
                    },
                    onEnterBack: function () {
                        swiperOp.slideTo(index);
                    },
                    onLeave: function () {
                        swiperOp.slideTo(index);
                    },
                    onLeaveBack: function () {
                        swiperOp.slideTo(index);
                    }
                }
            });
        });    
    }
}


function initScrollBackgroundTransition() {
  // Clean up previous ScrollTrigger instances for background transitions
  if (typeof ScrollTrigger !== 'undefined') {
    ScrollTrigger.getAll().forEach(trigger => {
      if (
        trigger.trigger &&
        trigger.trigger.hasAttribute &&
        trigger.trigger.hasAttribute('data-background')
      ) {
        trigger.kill();
      }
    });
    ScrollTrigger.refresh();
  }

  const sections = document.querySelectorAll('[data-background]');
  const root = document.documentElement;
  if (sections.length === 0) return;

  // Set initial CSS variable
  const initialColor = sections[0].getAttribute('data-background');
  root.style.setProperty('--bgcolor', initialColor);

  sections.forEach((section) => {
    const bgColor = section.getAttribute('data-background');

    ScrollTrigger.create({
      trigger: section,
      start: "top 70%",
      end: "bottom 80%",
      //markers: true, // remove in production
      onToggle: (self) => {
        if (self.isActive) {
          gsap.to(root, {
            '--bgcolor': bgColor,
            duration: 1.2,
            ease: "power2.out"
          });
          //console.log('active:', bgColor);
        }
      }
    });
  });
}



export { initScrollBackgroundTransition, scrollContent}